"use strict";
import { jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { TaskFlyout as TaskFlyoutPrimitive } from "capitalrx-components-2.0/lib/shell";
import { useContentChannel } from "./ContentChannel";
export const TaskFlyout = (props) => {
  const { onVisibilityChange } = props;
  const subscriptions = useContentChannel(null, "flyout-tasks");
  const taskSubscriptions = subscriptions.map((subscription) => {
    const { component: Component, params } = subscription;
    return {
      component: Component,
      params
    };
  });
  useEffect(() => {
    if (taskSubscriptions.length === 0) {
      onVisibilityChange == null ? void 0 : onVisibilityChange(false);
    } else {
      onVisibilityChange == null ? void 0 : onVisibilityChange(true);
    }
  }, [taskSubscriptions.length, onVisibilityChange]);
  return /* @__PURE__ */ jsx(TaskFlyoutPrimitive, { subscriptions: taskSubscriptions });
};
